"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var InfoDate = function InfoDate(_ref) {
  var date = _ref.date,
      columnRangeType = _ref.columnRangeType;
  var days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-align-center d-flex column justify-content-center pt"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "pt white"
  }, columnRangeType === 'DAY' ? days[date.getDay()] : "".concat(date, ":00"), '  ', columnRangeType === 'DAY' ? date.getDate() : null));
};

var _default = InfoDate;
exports["default"] = _default;